const TEMPORARILY_UNAVAILABLE_PRODUCT_IDS = Object.freeze([
	'gid://shopify/Product/7345430462567', // Rodin RapidCeram
	'gid://shopify/Product/7345446813799', // Rodin EnVision
	'gid://shopify/Product/6908629811303', // Rodin Titan
	'gid://shopify/Product/6908625911911', // Rodin Sculpture 2.0
	'gid://shopify/Product/6908632727655', // Rodin Denture Base 2.0
	'gid://shopify/Product/7419338063975', // BioArch RPD
	'gid://shopify/Product/7346083889255', // Rodin Try-In
	'gid://shopify/Product/7499845599335', // Rodin Surgical Guide 2.0
	'gid://shopify/Product/7499835900007', // Rodin Flexisplint
	'gid://shopify/Product/7499834064999', // Rodin Splint 2.0
	'gid://shopify/Product/7499855003751', // Rodin Ortho IBT
	'gid://shopify/Product/7499848220775', // Rodin Bite Tray
	'gid://shopify/Product/7211636359271', // Rodin N2-Free Glaze
	'gid://shopify/Product/7211598381159', // N2-Free Palette Naturalizing Kit
]);

const isProductPurchaseTemporarilyDisabled = function (productId) {
	const numericProductId = String(productId).split('/').pop();
	return TEMPORARILY_UNAVAILABLE_PRODUCT_IDS.includes(
		`gid://shopify/Product/${numericProductId}`,
	);
};

const arrayTakeAndSkip = function takeAndSkip(array, takeCount, skipCount) {
	if (!Array.isArray(array)) {
		// Check for valid input types
		return [];
	}
	if (typeof takeCount !== 'number' || typeof skipCount !== 'number') {
		// Check for valid input types
		return array;
	}

	let takenArray = array.slice(skipCount, skipCount + takeCount);
	return takenArray;
};

const isHideProduct = function (productId, currentCountryCode) {
	const isUSorCA = currentCountryCode === 'US' || currentCountryCode === 'CA';
	const isIe = currentCountryCode === 'IE';
	const hidedProductIds = {
		USorCA: [
			'gid://shopify/Product/7479252353127', // SOL SE
			'gid://shopify/Product/6857640837223', // SOL PLUS
		],
		international: [
			'gid://shopify/Product/7479392796775', // SOL SE with Concierge Service
			'gid://shopify/Product/7096869191783', // SOL PLUS with Concierge Service
		],
	};
	const currentAreaHideProductIds =
		isUSorCA || isIe ? hidedProductIds.USorCA : hidedProductIds.international;
	return currentAreaHideProductIds.includes(productId);
};

const shopStore = {
	namespaced: true,
	state: () => ({
		me: 'shop',
		cart: [],
		cartDiscountCodeArray: [],
		shopifyCart: null,
		sandBox: null,
		settings: {
			productsDefaultView: false,
			bundleView: false,
			pagination: {
				take: 9,
				takeMobile: 4,
				skip: 0,
				currentPage: 1,
				sortCriteria: PRODUCT_SORT_CRITERIA.HPF,
			},
		},
		isGettingProductPrice: false,
		getProductPriceQueue: [],
		requestedProductList: [],
		selectedProductList: [],
		checkedFiltersProductList: [],
		exchangeRates: {},
		productList: [],
		collectionProductList: [],
		toBeActiveAccordionList: [],
		paginationShopify: {
			take: 200,
			skip: 0,
			currentPage: 1,
			lastCursor: null,
			firstCursor: null,
		},
		soldOutProductIds: ['gid://shopify/Product/6555508670567'],
		shopifyStoreFrontAccessToken: 'f94fcaf2e0ca8dba7508cd0dcc300660',
		shopifyStoreFrontAccessUrl: 'https://ackuretta-shop.myshopify.com/api/2023-10/graphql.json',
		// shopifyStoreFrontClient: shopify.clients.Storefront({ // ShopifyBuy.buildClient
		//   domain: 'ackuretta-shop.myshopify.com',
		//   storefrontAccessToken: 'c3ddcc0e43bb4e669cef10045abba8d4',
		// })
	}),
	getters: {
		PRODUCT_SORT_CRITERIA: () => PRODUCT_SORT_CRITERIA,
		sortCriteria: (state) => state.settings.pagination.sortCriteria,
		me: (state) => state.me,
		cart: (state) => {
			if (window.localStorage.getItem('ack_shop_cart') && state.cart) {
				let parsedCart = JSON.parse(window.localStorage.getItem('ack_shop_cart'));
				let cart = parsedCart.map((m) => {
					const inventoryLocations = [
						INVENTORY_LOCATION_US,
						INVENTORY_LOCATION_TW,
						INVENTORY_LOCATION_US_2,
						INVENTORY_LOCATION_TW_2,
					];
					const isLocationVariantOnly = inventoryLocations.includes(m.variantTitle);
					const defaultTitle = m.variantTitle.split(' / ');
					const hasLocationAndOtherVariants =
						inventoryLocations.includes(defaultTitle[0]) && defaultTitle.length > 1;
					const variantTitle = isLocationVariantOnly
						? ''
						: hasLocationAndOtherVariants
							? defaultTitle[1]
							: m.variantTitle;
					const product = {
						...m,
						variantTitle,
					};
					return new CartItem(product);
				});
				appLog.log(cart, LOG_TYPE.varDump);
				return cart;
			}
			return state.cart;
		},
		cartDiscountCodeArray: (state) => {
			if (
				window.localStorage.getItem('ack_shop_cart_discount_codes') &&
				state.cartDiscountCodeArray
			) {
				let parsedDiscountCodes = JSON.parse(
					window.localStorage.getItem('ack_shop_cart_discount_codes'),
				);

				return parsedDiscountCodes;
			}
			return state.cartDiscountCodeArray;
		},
		shopifyCart: (state) => state.shopifyCart,
		sandBox: (state) => state.sandBox,
		settings: (state) => state.settings,
		requestedProductList: (state) => state.requestedProductList,
		selectedProductList: (state) => state.selectedProductList,
		checkedFiltersProductList: (state) => state.checkedFiltersProductList,
		numberOfSelectedProducts: (state) => state.selectedProductList.length,
		numberOfCartProducts: (state, getters, rootState, rootGetters) => getters.cart.length,
		numberOfCheckedFilters: (state) => state.checkedFiltersProductList.length,
		exchangeRates: (state) => state.exchangeRates,
		totalResults: (state) => {
			return state.productList.length;
		},
		totalPages: (state, getters, rootState, rootGetters) => {
			let totalResults = state.productList.length;
			let take = getters.resultsPerPage; //state.settings.pagination.take
			return Math.ceil(totalResults / take);
		},
		currentPage: (state) => {
			return state.settings.pagination.currentPage;
		},
		resultsPerPage: (state, getters, rootState, rootGetters) => {
			if (rootGetters.isMobile) {
				return state.settings.pagination.takeMobile;
			} else {
				return state.settings.pagination.take;
			}
		},
		productList: (state, getters, rootState, rootGetters) => {
			let retournedArr = [];
			retournedArr.push(...state.productList);

			switch (state.settings.pagination.sortCriteria) {
				case PRODUCT_SORT_CRITERIA.LPF:
					retournedArr.sort((a, b) => a.variants[0].priceV2.amount - b.variants[0].priceV2.amount);
					break;

				case PRODUCT_SORT_CRITERIA.HPF:
					retournedArr.sort((a, b) => b.variants[0].priceV2.amount - a.variants[0].priceV2.amount);
					break;

				case PRODUCT_SORT_CRITERIA.NEW:
					retournedArr.sort((a, b) => {
						let dateA = new Date(a.createdAt);
						let dateB = new Date(b.createdAt);
						return dateA - dateB;
					});

					retournedArr.reverse();
					break;
			}

			let take = getters.resultsPerPage; //state.settings.pagination.take
			let skip = state.settings.pagination.skip;
			let totalResults = state.productList.length;
			let currentPage = state.settings.pagination.currentPage;
			let totalPages = Math.ceil(totalResults / take);
			let takenNumberOfResults = take;

			let totalSkip = (currentPage - 1) * take;

			const specifyVariantLocation = (products) => {
				return products.map((product) => ({
					...product,
					variants: product.variants
						.filter((variant) => {
							const isUSorCA =
								getters.currentCountryCode === 'US' || getters.currentCountryCode === 'CA';
							if (variant.selectedOptions) {
								const location = variant.selectedOptions.find((data) => data.name === 'Location');
								if (!location) {
									return variant;
								}
								const isUsCa =
									location.value === INVENTORY_LOCATION_US ||
									location.value === INVENTORY_LOCATION_US_2;
								const isTw =
									location.value === INVENTORY_LOCATION_TW ||
									location.value === INVENTORY_LOCATION_TW_2;
								return isUSorCA ? isUsCa : isTw;
							}
							const hasLocation = [
								INVENTORY_LOCATION_US,
								INVENTORY_LOCATION_TW,
								INVENTORY_LOCATION_US_2,
								INVENTORY_LOCATION_TW_2,
							].includes(variant.title);
							if (hasLocation) {
								const isUsCa =
									variant.title === INVENTORY_LOCATION_US ||
									variant.title === INVENTORY_LOCATION_US_2;
								const isTw =
									variant.title === INVENTORY_LOCATION_TW ||
									variant.title === INVENTORY_LOCATION_TW_2;
								return isUSorCA ? isUsCa : isTw;
							}
							return variant;
						})
						.map((variant) => {
							// option 1 = inventory location
							// option 2 = product color
							const title = variant.title.split(' / ');
							return {
								...variant,
								title: title.length > 1 ? title[1] : title[0],
							};
						}),
				}));
			};

			retournedArr = arrayTakeAndSkip(retournedArr, take, totalSkip);
			retournedArr = specifyVariantLocation(retournedArr);

			return retournedArr;
		},
		collectionProductList: (state) => state.collectionProductList,
		toBeActiveAccordionList: (state) => state.toBeActiveAccordionList,
		numberOfProducts: (state) => state.productList.length,
		lastCursor: (state) => state.paginationShopify.lastCursor,
		firstCursor: (state) => state.paginationShopify.firstCursor,
		take: (state) => {
			return state.paginationShopify.take;
		},
		shopifyStoreFrontAccessToken: (state) => state.shopifyStoreFrontAccessToken,
		shopifyStoreFrontAccessUrl: (state) => state.shopifyStoreFrontAccessUrl,
		currentCurrency: (state, getters, rootState, rootGetters) => {
			return rootGetters['localization/currencyCode'];
		},
		currentCurrencySymbol: (state, getters, rootState, rootGetters) => {
			return rootGetters['localization/currencySymbol'];
		},
		currentCountryCode: (state, getters, rootState, rootGetters) => {
			return rootGetters['localization/countryCode'];
		},
		isStoreAvailable: (state, getters, rootState, rootGetters) => {
			return !(
				rootGetters['localization/countryCode'].toUpperCase() == 'US' ||
				rootGetters['localization/countryCode'].toUpperCase() == 'CA' ||
				rootGetters['localization/countryCode'].toUpperCase() === 'IE' ||
				rootGetters['localization/countryCode'].toUpperCase() == 'TW'
			);
		},
		isSoldOut: (state) => (productId) => {
			return state.soldOutProductIds.includes(productId);
		},
		totalCartPrice: (state, getters, rootState, rootGetters) => {
			let total = 0.0;
			for (let index = 0; index < getters.cart.length; index++) {
				const element = getters.cart[index];
				total += parseFloat(element.totalPrice);
			}
			return total;
		},

		totalSelectedPrice: (state, getters, rootState, rootGetters) => {
			let total = 0.0;
			for (let index = 0; index < getters.selectedProductList.length; index++) {
				const element = getters.selectedProductList[index];
				total += parseFloat(element.totalPrice);
			}
			return total;
		},

		isBundleView: (state) => {
			return state.settings.bundleView;
		},
	},
	mutations: {
		setRequesting(state, isRequesting) {
			state.isGettingProductPrice = isRequesting;
		},

		enqueueGetProductPrice(state, { request, resolve }) {
			state.getProductPriceQueue.push({ request, resolve });
		},

		processQueue(state) {
			if (state.getProductPriceQueue.length > 0 && !state.isGettingProductPrice) {
				const { request, resolve } = state.getProductPriceQueue.shift();
				state.isGettingProductPrice = true;

				// Avoid sending requests too frequently.
				setTimeout(async () => {
					try {
						const result = await request();
						resolve(result);
					} catch (error) {
						console.error('Error in queued request:', error);
						resolve(null);
					}
				}, 50);
			}
		},

		setSandBox(state, data) {
			state.sandBox = data;
		},

		setSortCriteria(state, data) {
			state.settings.pagination.sortCriteria = data;
		},

		setCurrentPage(state, data) {
			state.settings.pagination.currentPage = data;
		},

		setRequestedProduct(state, data) {
			state.requestedProductList.push(data);
		},

		unsetRequestedProduct(state, data) {
			let index = state.requestedProductList.indexOf(data);
			state.requestedProductList.splice(index, 1);
		},

		setLastCursor(state, data) {
			state.paginationShopify.lastCursor = data;
		},
		setFirstCursor(state, data) {
			state.paginationShopify.firstCursor = data;
		},
		setProductList(state, data) {
			const { productDatas, currentCountryCode } = data;
			state.productList = productDatas
				.map((m) => m.node)
				.filter((node) => {
					return !isHideProduct(node.id, currentCountryCode);
				})
				.map((node) => {
					try {
						node.img = node.images.edges[0].node.src;
						node.id = node.id; // .split('/')[node.id.split('/').length-1]
						node.variants = node.variants.edges.map((m) => {
							return m.node;
						});
						node.sellingPlanGroups = node.sellingPlanGroups.edges.map((m) => {
							let sp = m.node;

							sp.sellingPlans = sp.sellingPlans.edges.map((m) => {
								return m.node;
							});

							return sp;
						});
					} catch (error) {
						console.error(`Error processing node with id: ${node.id}`, error);
					}
					return node;
				});
		},
		setCollectionProductList(state, data) {
			state.collectionProductList = data.map((m) => m.node);
		},

		setExchangeRates(state, data) {
			state.exchangeRates = data;
		},
		// {  state/*, rootState, commit, dispatch*/, getters/*, rootGetters */ } // vuex 4 // NEED-TO migrate form Vuex 3 to Pinia
		addItemToCart(state, { data, cart }) {
			cart = JSON.parse(JSON.stringify(cart));
			if (data && typeof data[Symbol.iterator] === 'function') {
				cart.push(...data);
			} else {
				cart.push(data);
			}

			state.cart = cart;
			localStorage.setItem('ack_shop_cart', JSON.stringify(state.cart));
		},
		setCart(state, cart) {
			localStorage.setItem('ack_shop_cart', JSON.stringify(cart));
			state.cart = cart;
		},
		removeItemFromCart(state, { data, cart }) {
			cart = JSON.parse(JSON.stringify(cart));
			let item = cart.find((m) => {
				return m.variantId == data.variantId;
			});
			if (item != null) {
				let index = cart.indexOf(item);
				if (index != -1) {
					cart.splice(index, 1);
					state.cart = cart;
					localStorage.setItem('ack_shop_cart', JSON.stringify(state.cart));
				}
			}
		},

		setFilteredProductList(state, filteredProducts) {
			state.productList = filteredProducts;
		},
		addSoldOutProductId(state, productId) {
			if (!state.soldOutProductIds.includes(productId)) {
				state.soldOutProductIds.push(productId);
			}
		},

		removeSoldOutProductId(state, productId) {
			state.soldOutProductIds = state.soldOutProductIds.filter((id) => id !== productId);
		},

		addDiscountCodeToCart(state, { data, cartDiscountCodeArray }) {
			cartDiscountCodeArray = JSON.parse(JSON.stringify(cartDiscountCodeArray));
			if (Array.isArray(data)) {
				cartDiscountCodeArray.push(...data);
			} else {
				cartDiscountCodeArray.push(data);
			}

			state.cartDiscountCodeArray = cartDiscountCodeArray;
			localStorage.setItem(
				'ack_shop_cart_discount_codes',
				JSON.stringify(state.cartDiscountCodeArray),
			);
		},

		removeDiscountCodeFromCart(state, { data, cartDiscountCodeArray }) {
			cartDiscountCodeArray = JSON.parse(JSON.stringify(cartDiscountCodeArray));
			let item = cartDiscountCodeArray.find((m) => {
				return m == data;
			});
			if (item != null) {
				let index = cartDiscountCodeArray.indexOf(item);
				if (index != -1) {
					cartDiscountCodeArray.splice(index, 1);
					state.cartDiscountCodeArray = cartDiscountCodeArray;
					localStorage.setItem(
						'ack_shop_cart_discount_codes',
						JSON.stringify(state.cartDiscountCodeArray),
					);
				}
			}
		},

		addSelectedItem(state, data) {
			state.selectedProductList.push(data);
		},

		removeSelectedItem(state, data) {
			let item = state.selectedProductList.find((m) => {
				return m.variantId == data.variantId;
			});
			if (item != null) {
				let index = state.selectedProductList.indexOf(item);
				if (index != -1) {
					state.selectedProductList.splice(index, 1);
				}
			}
		},

		unselectAllProducts(state) {
			state.selectedProductList = [];
		},

		addCheckedFilter(state, data) {
			state.checkedFiltersProductList.push(data);
		},

		removeCheckedFilter(state, data) {
			let item = state.checkedFiltersProductList.find((m) => {
				return m.shopifyId == data.shopifyId;
			});
			if (item != null) {
				let index = state.checkedFiltersProductList.indexOf(item);
				if (index != -1) {
					state.checkedFiltersProductList.splice(index, 1);
				}
			}
		},

		clearAllFilters(state) {
			state.checkedFiltersProductList = [];
		},

		addToProductList(state, data) {
			let node = data;
			node.img = node.images.edges[0].node.src;
			node.variants = node.variants.edges.map((m) => {
				return m.node;
			});
			node.sellingPlanGroups = node.sellingPlanGroups.edges.map((m) => {
				let sp = m.node;

				sp.sellingPlans = sp.sellingPlans.edges.map((m) => {
					return m.node;
				});

				return sp;
			});

			if (state.settings.productsDefaultView || state.settings.bundleView) {
				state.productList = [];
				state.paginationShopify.currentPage = 1;
				state.settings.pagination.currentPage = 1;
				state.paginationShopify.firstCursor = null;
				state.paginationShopify.lastCursor = null;
				state.settings.productsDefaultView = false;
				state.settings.bundleView = false;
			}

			state.productList.push(node);
		},

		removeFromProductList(state, data) {
			let element = state.productList.find((m) => {
				return m.id == data;
			});

			if (element != undefined) {
				let index = state.productList.indexOf(element);

				state.productList.splice(index, 1);
			}
		},

		setProductsDefaultView(state) {
			state.settings.productsDefaultView = true;
		},

		setBundleView(state) {
			state.settings.bundleView = true;
		},

		unsetBundleView(state) {
			state.settings.bundleView = false;
		},

		setShopifyCart(state, data) {
			state.shopifyCart = data;
		},

		addToAccordionList(state, data) {
			state.toBeActiveAccordionList.push(data);
		},
		resetAccordionList(state, data) {
			state.toBeActiveAccordionList = data;
		},
		updateAccordionList(state, data) {
			if (state.toBeActiveAccordionList.includes(data)) return;
			state.toBeActiveAccordionList.push(data);
		},
	},
	actions: {
		sayHi() {
			appLog.log('HIIIIII shop', LOG_TYPE.debug);
		},
		addCheckedFilter({ commit }, productFilter) {
			commit('addCheckedFilter', productFilter);
		},
		addAccordion({ commit }, accordion) {
			commit('addToAccordionList', accordion);
		},
		emptyAccordionList({ commit }) {
			commit('resetAccordionList', []);
		},
		updateAccordionList({ commit }, accordionId) {
			commit('updateAccordionList', accordionId);
		},
		removeCheckedFilter({ commit }, productFilter) {
			commit('removeCheckedFilter', productFilter);
		},

		clearAllFilters({ commit, dispatch }) {
			commit('clearAllFilters');
			dispatch('setProductsDefaultView');
		},

		setSortCriteria({ commit }, sortCriteria) {
			commit('setSortCriteria', sortCriteria);
		},

		setCurrentPage({ commit }, currentPage) {
			commit('setCurrentPage', currentPage);
		},

		markAsSoldOut({ commit }, productId) {
			commit('addSoldOutProductId', productId);
		},

		markAsAvailable({ commit }, productId) {
			commit('removeSoldOutProductId', productId);
		},

		setProductsDefaultView({ commit, dispatch, getters }, params /*{tag, reverse}*/) {
			commit('setProductsDefaultView');

			let tag;
			if (params && params.tag) {
				tag = params.tag;
			} else {
				tag =
					getters.currentCountryCode === 'US' || getters.currentCountryCode === 'CA'
						? 'shop-featured-product-us-ca'
						: 'shop-product';
			}

			let reverse = params ? params.reverse : null;

			console.log('tag:', tag);

			return dispatch('getProducts', { tag, sortByPrice: true, reverse });
		},

		setBundleView({ commit, dispatch }, params /*{tag, reverse}*/) {
			commit('setBundleView');
			let tag = params ? params.tag : 'shop-3dps-1';
			let reverse = params ? params.reverse : null;

			return dispatch('getProducts', { tag, sortByPrice: true, reverse });
		},

		emptyCart({ commit }) {
			commit('setCart', []);
		},

		addSelectedItem({ commit }, product) {
			commit('addSelectedItem', new CartItem(product));
		},

		removeSelectedItem({ commit }, product) {
			commit('removeSelectedItem', new CartItem(product));
		},

		unselectAllProducts({ commit }) {
			EventBus.$emit('unselect-all-products');
			commit('unselectAllProducts');
		},

		// WORKAROUND: use queue to avoid send the multiple requests at the same time, it shall accept the array data of the field of lines
		async getProductPrice({ getters, state, commit }, { variantId, sellingPlanId }) {
			const executeRequest = async () => {
				const query = `
          mutation {
            cartCreate(
              input: {
                lines: [
                  {
                    quantity: 1,
                    merchandiseId: "${variantId}",
                    ${sellingPlanId ? `sellingPlanId: "${sellingPlanId}"` : ''}
                  }
                ],
                buyerIdentity: {
                  countryCode: ${getters.currentCountryCode},
                },
              }
            ) {
              cart {
                cost {
                  totalAmount {
                    amount
                    currencyCode
                  }
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalTaxAmount {
                    amount
                    currencyCode
                  }
                  totalDutyAmount {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        `;

				const headers = {
					'Content-Type': 'application/json',
					'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
				};

				try {
					const response = await fetch(getters.shopifyStoreFrontAccessUrl, {
						method: 'POST',
						headers: headers,
						body: JSON.stringify({ query }),
					});

					const json = await response.json();
					const priceInfo = json.data.cartCreate.cart?.cost?.subtotalAmount;
					return priceInfo || null;
				} catch (error) {
					console.error('Error fetching cart price:', error);
					return null;
				} finally {
					commit('setRequesting', false);
					commit('processQueue');
				}
			};

			if (state.isGettingProductPrice) {
				return new Promise((resolve) => {
					commit('enqueueGetProductPrice', {
						request: executeRequest,
						resolve,
					});
				});
			} else {
				commit('setRequesting', true);
				return executeRequest();
			}
		},

		increaseCartItemQuantity({ commit, getters }, { variantId: id, quantity }) {
			if (
				id != 'gid://shopify/ProductVariant/41256766079079' &&
				id != 'gid://shopify/ProductVariant/40179161137255' &&
				id != 'gid://shopify/Product/6779701428327' &&
				id != 'gid://shopify/Product/6779706933351'
			) {
				let cart = JSON.parse(JSON.stringify(getters.cart));
				let item = cart.find((m) => {
					return m.variantId == id;
				});
				if (item != null) {
					let index = cart.indexOf(item);

					cart[index].quantity = parseInt(cart[index].quantity) + parseInt(quantity);

					commit('setCart', cart);
				} else {
					// product not in cart
				}
			} else {
				// product is a subscription and only one subs per user
			}
		},

		addToCart({ commit, getters, dispatch }, productOrProducts) {
			let cart = JSON.parse(JSON.stringify(getters.cart));
			const countryCode = getters.currentCountryCode;
			const restrictedCountries = ['US', 'CA'];
			const restrictedProductId = [
				'gid://shopify/Product/6555508670567', //CURIE
				'gid://shopify/Product/6627055435879', // CURO Crown
				'gid://shopify/Product/6624780812391', // CURO Model
				'gid://shopify/Product/6624785760359', //CURO proDenture
				'gid://shopify/Product/6627062448231', // CURO ProSplint Soft
			];

			const soldOutProductId = [
				'gid://shopify/Product/6555508670567', // CURIE
				'gid://shopify/Product/6548762591335', // DENTIQ
			];

			const addItemToCart = (item) => {
				if (isProductPurchaseTemporarilyDisabled(item.productId)) {
					return;
				}

				// Check if the item is the sold-out product
				if (soldOutProductId.includes(item.productId)) {
					return;
				}

				if (
					restrictedProductId.includes(item.productId) &&
					restrictedCountries.includes(countryCode)
				) {
					return;
				}

				const variantGid = 'gid://shopify/ProductVariant';
				const productGid = 'gid://shopify/Product';
				const alphaAis = [`${variantGid}/41256766079079`, `${variantGid}/40179161137255`];
				const concierges = [`${productGid}/6779701428327`, `${productGid}/6779706933351`];
				const isExisting = (arr, id) => arr.includes(id);
				const alphaItem = cart.find((m) => isExisting(alphaAis, m.variantId));
				const conciregeItem = cart.find((m) => isExisting(concierges, m.productId));
				const isSameAlphaAiItem = alphaItem && isExisting(alphaAis, item.variantId);
				const isSameAckurettaConcierge = conciregeItem && isExisting(concierges, item.productId);
				if (isSameAlphaAiItem || isSameAckurettaConcierge) {
					console.warn('Alpha item or Concierge item already in the cart. Skipping addition.');
					return;
				}

				let cartItem = cart.find((m) => m.variantId == item.variantId);
				if (cartItem) {
					let index = cart.indexOf(cartItem);
					cart[index].quantity += parseInt(item.quantity);
				} else {
					cart.push(new CartItem(item));
				}
			};

			if (Array.isArray(productOrProducts)) {
				productOrProducts.forEach((element) => {
					if (element.sellingPlanId) {
						dispatch('getProductPrice', {
							variantId: element.variantId,
							sellingPlanId: element.sellingPlanId,
						})
							.then((priceInfo) => {
								if (priceInfo) {
									element.pricePerUnit = parseFloat(priceInfo.amount);
									element.currencyCode = priceInfo.currencyCode;
								}
								addItemToCart(element);
								commit('setCart', cart);
								EventBus.$emit('shop-cart-items-change');
							})
							.catch((error) => {
								console.error('Error fetching cart price:', error);
								addItemToCart(element);
								commit('setCart', cart);
								EventBus.$emit('shop-cart-items-change');
							});
					} else {
						addItemToCart(element);
						commit('setCart', cart);
						EventBus.$emit('shop-cart-items-change');
					}
				});
			} else {
				let item = productOrProducts;
				if (item.sellingPlanId) {
					dispatch('getProductPrice', {
						variantId: item.variantId,
						sellingPlanId: item.sellingPlanId,
					})
						.then((priceInfo) => {
							if (priceInfo) {
								item.pricePerUnit = parseFloat(priceInfo.amount);
								item.currencyCode = priceInfo.currencyCode;
							}
							addItemToCart(item);
							commit('setCart', cart);
							EventBus.$emit('shop-cart-items-change');
						})
						.catch((error) => {
							console.error('Error fetching cart price:', error);
							addItemToCart(item);
							commit('setCart', cart);
							EventBus.$emit('shop-cart-items-change');
						});
				} else {
					addItemToCart(item);
					commit('setCart', cart);
					EventBus.$emit('shop-cart-items-change');
				}
			}
		},

		removeFromCart({ commit, getters }, product) {
			let cart = getters.cart;
			let data = new CartItem(product);
			commit('removeItemFromCart', { data, cart });

			EventBus.$emit('shop-cart-items-change');
		},

		addDiscountCodeToCart({ commit, getters }, discountCode) {
			commit('addDiscountCodeToCart', {
				cartDiscountCodeArray: getters.cartDiscountCodeArray,
				data: discountCode,
			});
		},

		removeDiscountCodeFromCart({ commit, getters }, discountCode) {
			commit('removeDiscountCodeFromCart', {
				cartDiscountCodeArray: getters.cartDiscountCodeArray,
				data: discountCode,
			});
		},

		getProducts(
			{ commit, dispatch, getters },
			{ cursor, goingBackwards, tag, sortByPrice, reverse },
		) {
			let query = `
			  query allProducts @inContext(country: ${getters.currentCountryCode}){
			    products(first: ${getters.take}${cursor ? `, ${goingBackwards ? 'before' : 'after'}: "${cursor}"` : ''}${tag ? `, query: "tag:${tag}"` : ''}${sortByPrice ? `, sortKey: PRICE` : ''}${reverse ? `, reverse: true` : `, reverse: false`}) {
          edges {
            cursor
            node {
              id
              title
              handle
              tags
              createdAt
              onlineStoreUrl
              publishedAt
              totalInventory
              updatedAt
              sellingPlanGroups(first: 20) {
                edges {
                  node {
                    name
                    sellingPlans(first: 20) {
                      edges {
                        node {
                          id
                          name
                          checkoutCharge {
                            value {
                              ... on MoneyV2 {
                                __typename
                                amount
                                currencyCode
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
              variants(first: 20) {
                edges {
                  node {
                    id
                    title
                    quantityAvailable
                    priceV2 {
                      amount
                      currencyCode
                    }
                    sku
                    barcode
                    image {
                      src
                    }
                    selectedOptions {
                      name
                      value
                    }
                  }
                }
              }
              images(first: 1) {
                edges {
                  node {
                    id
                    src
                    altText
                  }
                }
              }
            }

          }
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
        }
      }
    `;
			// Define request headers
			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					// Handle the response data (products) here
					appLog.log(jsonObj);

					dispatch('unselectAllProducts');

					EventBus.$emit('shop-unselect-all-filters');
					commit('setProductList', {
						productDatas: jsonObj.data.products.edges,
						currentCountryCode: getters.currentCountryCode,
					});

					commit('setCollectionProductList', jsonObj.data.products.edges);

					commit(
						'setLastCursor',
						jsonObj.data.products.edges[jsonObj.data.products.edges.length - 1].cursor,
					);
					commit('setFirstCursor', jsonObj.data.products.edges[0].cursor);
				})
				.catch((error) => {
					// Handle errors
					appLog.error(error);
				});
		},

		getProduct({ commit, dispatch, getters }, id) {
			let reqElement = getters.requestedProductList.find((m) => {
				return m == id;
			});
			if (reqElement != undefined) {
				return;
			} else {
				commit('setRequestedProduct', id);
			}

			let listElement = getters.productList.find((m) => {
				return m.id == id;
			});
			if (
				listElement != undefined &&
				getters.settings.productsDefaultView === false &&
				getters.settings.bundleView === false
			) {
				return;
			}

			let query = `
      query allProducts @inContext(country: ${getters.currentCountryCode}){
        product(id: "${id}") {
          id
          title
          handle
          tags
          createdAt
          onlineStoreUrl
          publishedAt
          totalInventory
          updatedAt
          sellingPlanGroups(first: 20) {
            edges {
              node {
                name
                sellingPlans(first: 20) {
                  edges {
                    node {
                      id
                      name
                      checkoutCharge {
                        value {
                          ... on MoneyV2 {
                            __typename
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          variants(first: 20) {
            edges {
              node {
                id
                title
                quantityAvailable
                priceV2 {
                  amount
                  currencyCode
                }
                sku
                barcode
                image {
                  src
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
          images(first: 1) {
            edges {
              node {
                id
                src
                altText
              }
            }
          }
        }
      }
    `;

			// Define request headers
			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					// Handle the response data (products) here
					appLog.log(jsonObj);

					if (getters.settings.bundleView || getters.settings.productsDefaultView) {
						dispatch('unselectAllProducts');
					}
					commit('addToProductList', jsonObj.data.product);

					commit('unsetRequestedProduct', jsonObj.data.product.id);
				})
				.catch((error) => {
					// Handle errors
					appLog.error(error);
				});
		},

		addToCartFromProperties(
			{ dispatch, getters },
			{ productId, variantId, sellingPlanId, quantity, imgOverride },
		) {
			return dispatch('getCartItem', {
				productId,
				variantId,
				sellingPlanId,
				quantity,
				imgOverride,
			})
				.then((cartItem) => {
					if (!cartItem) {
						throw new Error('CartItem is null');
					}

					if (sellingPlanId) {
						dispatch('getProductPrice', { variantId, sellingPlanId })
							.then((priceInfo) => {
								if (priceInfo) {
									cartItem.pricePerUnit = parseFloat(priceInfo.amount);
									cartItem.currencyCode = priceInfo.currencyCode;
								}
								dispatch('addToCart', cartItem);
							})
							.catch((error) => {
								console.error('Error fetching cart price:', error);
								dispatch('addToCart', cartItem);
							});
					} else {
						dispatch('addToCart', cartItem);
					}
				})
				.catch((error) => {
					console.error('Error adding to cart from properties:', error);
				});
		},

		getCartItem(
			{ dispatch, rootGetters },
			{ productId, variantId, sellingPlanId, quantity, imgOverride },
		) {
			const isUS_CA = rootGetters['localization/isUS_CA'];
			return dispatch('recoverProductInfo', productId).then((recoveredProduct) => {
				let cartItem = new CartItem();
				cartItem.fillFromRecoveredProduct(recoveredProduct, variantId, sellingPlanId, quantity, {
					isUS_CA,
				});

				if (imgOverride) {
					cartItem.img = imgOverride;
				}

				return cartItem;
			});
		},

		recoverProductInfo({ getters }, id) {
			let query = `
      query allProducts @inContext(country: ${getters.currentCountryCode}){
        product(id: "${id}") {
          id
          title
          handle
          tags
          createdAt
          onlineStoreUrl
          publishedAt
          totalInventory
          updatedAt
          sellingPlanGroups(first: 20) {
            edges {
              node {
                name
                sellingPlans(first: 20) {
                  edges {
                    node {
                      id
                      name
                      checkoutCharge {
                        value {
                          ... on MoneyV2 {
                            __typename
                            amount
                            currencyCode
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          variants(first: 20) {
            edges {
              node {
                id
                title
                quantityAvailable
                priceV2 {
                  amount
                  currencyCode
                }
                sku
                barcode
                image {
                  src
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
          images(first: 1) {
            edges {
              node {
                id
                src
                altText
              }
            }
          }
        }
      }
    `;

			// Define request headers
			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					let node = jsonObj.data.product;
					node.img = node.images.edges[0].node.src;
					node.variants = node.variants.edges.map((m) => {
						return m.node;
					});
					node.sellingPlanGroups = node.sellingPlanGroups.edges.map((m) => {
						let sp = m.node;

						sp.sellingPlans = sp.sellingPlans.edges.map((m) => {
							return m.node;
						});

						return sp;
					});

					return node;
				})
				.catch((error) => {
					// Handle errors
					appLog.error(error);
					return null;
				});
		},

		removeProduct({ commit, getters, dispatch }, id) {
			commit('removeFromProductList', id);
			if (getters.productList.length == 0) {
				dispatch('setProductsDefaultView');
			}
		},

		buyNow({ commit, getters }, { variantId, sellingPlanId, discountCodeArray, quantity }) {
			quantity = quantity ? quantity : 1;

			let discountCodes = '';

			if (
				discountCodeArray != null &&
				Array.isArray(discountCodeArray) &&
				discountCodeArray.length > 0
			) {
				discountCodes = discountCodeArray
					.map((m) => {
						return `"${m}"`;
					})
					.join(',');
			}

			let query = `mutation {
        cartCreate(
          input: {
            lines: [
              {
                quantity: ${quantity},
                merchandiseId: "${variantId}",
                ${sellingPlanId ? `sellingPlanId: "${sellingPlanId}"` : ''}
              }
            ],
            discountCodes: [
              ${discountCodes}
            ],
            # The information about the buyer that's interacting with the cart.
            buyerIdentity: {
              email: null,
              countryCode: ${getters.currentCountryCode},
              # An ordered set of delivery addresses associated with the buyer that's interacting with the cart. The rank of the preferences is determined by the order of the addresses in the array. You can use preferences to populate relevant fields in the checkout flow.
              deliveryAddressPreferences: {
                deliveryAddress: {
                  address1: "150 Elgin Street",
                  address2: "8th Floor",
                  city: "Ottawa",
                  province: "Ontario",
                  country: "CA",
                  zip: "K2P 1L4"
                },
              }
            }
            attributes: {
              key: "cart_attribute",
              value: "This is a cart attribute"
            }
          }
        ) {
          cart {
            id
            createdAt
            updatedAt
            checkoutUrl

            buyerIdentity {
              deliveryAddressPreferences {
                __typename
              }
            }
            attributes {
              key
              value
            }
            # The estimated total cost of all merchandise that the customer will pay at checkout.
            cost {
              totalAmount {
                amount
                currencyCode
              }
              # The estimated amount, before taxes and discounts, for the customer to pay at checkout.
              subtotalAmount {
                amount
                currencyCode
              }
              # The estimated tax amount for the customer to pay at checkout.
              totalTaxAmount {
                amount
                currencyCode
              }
              # The estimated duty amount for the customer to pay at checkout.
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }

    `;

			// Define request headers
			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					// Handle the response data here
					appLog.log(jsonObj);
					commit('setShopifyCart', jsonObj.data.cartCreate.cart);
					return getters.shopifyCart.checkoutUrl;
				})
				.catch((error) => {
					// Handle errors
					appLog.error(error);
				});
		},

		buyNowMany({ commit, getters }, { itemInfoArray, discountCodeArray }) {
			const restrictedProductId = [
				'gid://shopify/Product/6555508670567', // CURIE
				'gid://shopify/Product/6627055435879', // CURO Crown
				'gid://shopify/Product/6624780812391', // CURO Model
				'gid://shopify/Product/6624785760359', // CURO proDenture
			];

			const soldOutProductId = [
				'gid://shopify/Product/6555508670567', // CURIE
				'gid://shopify/Product/6548762591335', // DENTIQ
			];

			// Filter out restricted products
			itemInfoArray = itemInfoArray.filter(
				(item) =>
					!restrictedProductId.includes(item.productId) &&
					!soldOutProductId.includes(item.productId) &&
					!isProductPurchaseTemporarilyDisabled(item.productId),
			);

			let discountCodes = '';

			if (
				discountCodeArray != null &&
				Array.isArray(discountCodeArray) &&
				discountCodeArray.length > 0
			) {
				discountCodes = discountCodeArray
					.map((m) => {
						return `"${m}"`;
					})
					.join(',');
			}

			let lines = '';

			for (let index = 0; index < itemInfoArray.length; index++) {
				const element = itemInfoArray[index];

				let { variantId, sellingPlanId, quantity } = element;

				let line = '';

				if (index !== 0) {
					line += ',';
				}

				quantity = quantity ? quantity : 1;
				line += `{
          quantity: ${quantity},
          merchandiseId: "${variantId}",
          ${sellingPlanId ? `sellingPlanId: "${sellingPlanId}"` : ''}
        }\n`;

				lines += line;
			}

			let query = `mutation {
        cartCreate(
          input: {
            lines: [
              ${lines}
            ],
            discountCodes: [
              ${discountCodes}
            ],
            buyerIdentity: {
              email: null,
              countryCode: ${getters.currentCountryCode},
              deliveryAddressPreferences: {
                deliveryAddress: {
                  address1: "150 Elgin Street",
                  address2: "8th Floor",
                  city: "Ottawa",
                  province: "Ontario",
                  country: "CA",
                  zip: "K2P 1L4"
                },
              }
            }
            attributes: {
              key: "cart_attribute",
              value: "This is a cart attribute"
            }
          }
        ) {
          cart {
            id
            createdAt
            updatedAt
            checkoutUrl

            buyerIdentity {
              deliveryAddressPreferences {
                __typename
              }
            }
            attributes {
              key
              value
            }
            cost {
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
              totalTaxAmount {
                amount
                currencyCode
              }
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }`;

			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					appLog.log(jsonObj);
					commit('setShopifyCart', jsonObj.data.cartCreate.cart);
					return getters.shopifyCart.checkoutUrl;
				})
				.catch((error) => {
					appLog.error(error);
				});
		},

		checkoutCart({ commit, getters }) {
			let discountCodes = '';
			let discountCodeArray = getters.cartDiscountCodeArray;
			if (
				discountCodeArray != null &&
				Array.isArray(discountCodeArray) &&
				discountCodeArray.length > 0
			) {
				discountCodes = discountCodeArray
					.map((m) => {
						return `"${m}"`;
					})
					.join(',');
			}

			let stringLines = '';
			let array = getters.cart.filter(
				(item) => !isProductPurchaseTemporarilyDisabled(item.productId),
			);
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				let text = '';
				if (index !== 0) {
					text += ',';
				}
				text += `{
          quantity: ${element.quantity ? element.quantity : 1},
          merchandiseId: "${element.variantId}",
          ${element.sellingPlanId ? `sellingPlanId: "${element.sellingPlanId}"` : ''}
        }\n`;

				stringLines += text;
			}

			let query = `mutation {
        cartCreate(
          input: {
            lines: [
              ${stringLines}
            ],
            discountCodes: [
              ${discountCodes}
            ],
            # The information about the buyer that's interacting with the cart.
            buyerIdentity: {
              email: null,
              countryCode: ${getters.currentCountryCode},
              # An ordered set of delivery addresses associated with the buyer that's interacting with the cart. The rank of the preferences is determined by the order of the addresses in the array. You can use preferences to populate relevant fields in the checkout flow.
              deliveryAddressPreferences: {
                deliveryAddress: {
                  address1: "150 Elgin Street",
                  address2: "8th Floor",
                  city: "Ottawa",
                  province: "Ontario",
                  country: "CA",
                  zip: "K2P 1L4"
                },
              }
            }
            attributes: {
              key: "cart_attribute",
              value: "This is a cart attribute"
            }
          }
        ) {
          cart {
            id
            createdAt
            updatedAt
            checkoutUrl

            buyerIdentity {
              deliveryAddressPreferences {
                __typename
              }
            }
            attributes {
              key
              value
            }
            # The estimated total cost of all merchandise that the customer will pay at checkout.
            cost {
              totalAmount {
                amount
                currencyCode
              }
              # The estimated amount, before taxes and discounts, for the customer to pay at checkout.
              subtotalAmount {
                amount
                currencyCode
              }
              # The estimated tax amount for the customer to pay at checkout.
              totalTaxAmount {
                amount
                currencyCode
              }
              # The estimated duty amount for the customer to pay at checkout.
              totalDutyAmount {
                amount
                currencyCode
              }
            }
          }
        }
      }

    `;

			// Define request headers
			let headers = {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': getters.shopifyStoreFrontAccessToken,
			};
			return fetch(getters.shopifyStoreFrontAccessUrl, {
				method: 'POST',
				headers: headers,
				body: JSON.stringify({ query: query }),
			})
				.then((response) => response.json())
				.then((jsonObj) => {
					// Handle the response data here
					appLog.log(jsonObj);
					commit('setShopifyCart', jsonObj.data.cartCreate.cart);
					return getters.shopifyCart.checkoutUrl;
				})
				.catch((error) => {
					// Handle errors
					appLog.error(error);
				});
		},
	},
};

vStore.registerModule('shop', shopStore);
